import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { BatchFormValues } from "src/models/Batch.model";
import {
  useGetBatchByIdQuery,
  useUpdateBatchMutation,
} from "src/services/BatchServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import BatchForm from "../Layouts/BatchForm";

type Props = {
  onClose: () => void;
  batchId: string;
};

const EditBatchFormWrapper = ({ onClose, batchId = "" }: Props) => {
  const [batchData, setBatchData] = useState<any>(null);

  const { data, isLoading, isFetching } = useGetBatchByIdQuery(batchId);
  const [updateBatch] = useUpdateBatchMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setBatchData(data?.data || null);
    }
  }, [data, isLoading, isFetching]);

  // Form Initial Values
  const initialValues: BatchFormValues = {
    batchName: batchData?.batchName || "",
    weekOffs:batchData?.weekOffs?.map((el:any)=>{
      return{
        label: el ,
        value : el
      }
    }),
    plan:{
      label:batchData?.plans?.[0]?.planName ,
      value : batchData?.plans?.[0]?._id
    },
    course: {
      label: "MERN",
      value: "655f354ee3b708c2fece8b26",
    },
    mode: {
      _id: batchData?.modeId,
      modeName: batchData?.modeName,
    },
    allBranches: batchData?.allBranches,
    branches: batchData?.branchId?.map((branch: any) => ({
      label: branch.branchName,
      value: branch._id,
    })),
    startDate: batchData?.startDate
      ? moment(batchData?.startDate, "yyyy-MM-DD")
      : null,
    startTime: batchData?.time
      ? moment(batchData?.time?.split("-")?.[0]?.trim(), "hh:mm A")
      : null,
    endTime: batchData?.time?.split("-")?.[1]
      ? moment(batchData?.time?.split("-")?.[1]?.trim(), "hh:mm A")
      : null,
    trainers: batchData?.trainers?.map((trainer: any) => ({
      label: trainer.name,
      value: trainer._id,
    })),
    language: {
      languageName: batchData?.languageName,
      _id: batchData?.language,
    },
    fees: batchData?.fees || "",
    seats: batchData?.noOfSeats || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    batchName: string().required("Please enter batch name"),
    course: object().required("Please select course"),
    mode: object().required("Please select mode"),
    startDate: string().required("Please select start date"),
    startTime: string().required("Please select start time"),
    endTime: string().required("Please select end time"),
    fees: string().required("Please enter fees"),
    seats: string().required("Please enter no of seats"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BatchFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BatchFormValues>
  ) => {
    const formattedValues = {
      allBranches: values.allBranches,
      batchName: values?.batchName,
      weekOffs :values?.weekOffs?.map((el:any)=>el?.value)  ,
      planId:values?.plan?.value ,
      batchCourses: values?.course?.value,
      modeId: values?.mode?._id,
      branchId: values?.branches?.map((branch) => branch?.value),
      startDate: values?.startDate
        ? moment(values?.startDate).format("yyyy-MM-DD")
        : "",
      estimatedEndDate: "",
      time: `${
        values?.startTime ? moment(values?.startTime).format("hh:mm A") : ""
      } ${
        values?.endTime ? `- ${moment(values?.endTime).format("hh:mm A")}` : ""
      } `,
      trainers: values?.trainers?.map((trainer) => trainer?.value),
      language: values?.language?._id,
      fees: values?.fees,
      noOfSeats: values?.seats,
    };
    updateBatch({ body: formattedValues, batchId: batchId }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );  
  };

  return (
    <Dialog open maxWidth='xl' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BatchForm
              formikProps={formikProps}
              onClose={onClose}
              isLoading={isLoading || isFetching}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditBatchFormWrapper;
